import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as integrationsDuck from '../../_augmentt/ducks/integrations'
import { getIntegrations, OFFICE365 } from '../crud/integration.crud'

const useCustomerIntegration = ({ selectedCustomerId, defaultSelection = OFFICE365 }) => {
  const dispatch = useDispatch()
  const customerIntegration = useSelector(({ integrations }) => integrations.selectedIntegration)

  useEffect(() => {
    const getCustomerIntegrations = async () => {
      const result = await getIntegrations(selectedCustomerId)
      const defaultIntegration =
        result?.data?.find((item) => item.IntegrationApplication.application_name === defaultSelection) ??
        result?.data?.[0]

      dispatch(integrationsDuck.actions.setSelectedIntegration(defaultIntegration))
      dispatch(integrationsDuck.actions.setIntegrations(result?.data))
    }

    if (selectedCustomerId) {
      getCustomerIntegrations()
    } else {
      dispatch(integrationsDuck.actions.setSelectedIntegration(null))
      dispatch(integrationsDuck.actions.setIntegrations([]))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCustomerId, dispatch])

  return customerIntegration
}

export default useCustomerIntegration
